var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header'),_vm._v(" "),(_vm.isAdministrator)?_c('Sidebar'):_vm._e(),_vm._v(" "),(_vm.isAdministrator)?_c('Dashboard'):_vm._e(),_vm._v(" "),(!_vm.isAdministrator)?_c('Todo'):_vm._e(),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680e9914","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = null
// module chunks = 